import React from "react";
import PropTypes from "prop-types";

/**
 * Komponente zum auf-zuklappen.
 *
 * Sollte eventuell noch mit einer Transition umgebaut werden
 * @param open
 * @param children
 * @param rest
 * @returns {JSX.Element|null}
 * @constructor
 */
function EASlide({ open, children, ...rest }) {
    return open ? <div {...rest}>{children}</div> : null;
}

EASlide.propTypes = {
    open: PropTypes.bool,
};

export default EASlide;
